import { lightTheme } from '../themes/light.js';
export const defaultTheme = lightTheme;
//# sourceMappingURL=Theme.js.map